export const LEFT_SLOT = 'left_slot';
export const RIGHT_SLOT = 'right_slot';
export const SLOT1 = 'slot1';
export const SLOT2 = 'slot2';